// extracted by mini-css-extract-plugin
module.exports = {"ControlloCF":"ControlloCF_ControlloCF__20KUp","strong":"ControlloCF_strong__3mTdk"};